import { gql } from '@apollo/client';

/**
 * Query para obtener la configuración completa del tenant actual
 */
export const GET_APP_CONFIG = gql`
  query GetAppConfig {
    appConfig {
      id
      availableConcessionIds
      tenantId
      createdAt
      updatedAt
    }
  }
`;

/**
 * Query para obtener una configuración/feature flag por clave
 */
export const GET_CONFIG = gql`
  query GetConfig($key: String!) {
    getConfig(key: $key)
  }
`;

/**
 * Query para obtener todas las configuraciones del tenant actual
 */
export const GET_ALL_CONFIGS = gql`
  query GetAllConfigs {
    getAllConfigs
  }
`;
